export default {
  BORDER_SCOPE: 10, // resize区域的宽度
  AVAILABLE_CLICK_MAX_MOVE_DISTANCE: 4, // 在move中，超出这个距离的话将把click事件吞掉
  AVAILABLE_CLICK_MAX_RESIZE_DISTANCE: 4, // 在resize中，超出这个距离的话将把click事件吞掉
};
